import { requestJson } from './http';

const API_BASE_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:8000';

function authHeaders(): Record<string, string> {
  const token = localStorage.getItem('auth_token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export interface Listener {
  listener_id: string;
  household_id: string;
  display_name: string;
  age_band: string | null;
  state: string;
  bookends?: {
    intro: boolean;
    goodnight: boolean;
  };
  bookend_complete?: boolean;
}

export async function fetchListeners(signal?: AbortSignal): Promise<Listener[]> {
  return requestJson<Listener[]>(`${API_BASE_URL}/listeners`, { headers: authHeaders(), signal });
}

export async function resolveListener(displayName: string): Promise<Listener> {
  return requestJson<Listener>(`${API_BASE_URL}/listeners/resolve`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ display_name: displayName }),
  });
}

export async function fetchVoiceListeners(voiceId: string, signal?: AbortSignal): Promise<Listener[]> {
  return requestJson<Listener[]>(
    `${API_BASE_URL}/voice/voices/${encodeURIComponent(voiceId)}/listeners`,
    { headers: authHeaders(), signal }
  );
}

export async function updateListener(
  listenerId: string,
  changes: Partial<Pick<Listener, 'display_name' | 'age_band' | 'state'>>
): Promise<Listener> {
  return requestJson<Listener>(`${API_BASE_URL}/listeners/${encodeURIComponent(listenerId)}`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify(changes),
  });
}
